import React from 'react';
import { icons } from '../../assets';
import * as s from './styled-register';

const Aprovacao = ({ username, email, phoneNumber }) => {
  return (
    <s.FormContainer url="RegisterOpaqueRight.svg">
      <div id="content">
        <s.Title margin="0 0 10px 0">Cadastrar</s.Title>
        <s.SubTitle>Confirme seus dados.</s.SubTitle>

        <s.Resume>
          <div id="item">
            <s.Icon src={icons.PersonIcon} />
            <label>{username}</label>
          </div>
          <div id="item">
            <s.Icon src={icons.PhoneIcon} size="30px" />
            <label>{phoneNumber}</label>
          </div>
          <div id="item">
            <s.Icon src={icons.EmailIcon} />
            <label>{email}</label>
          </div>
        </s.Resume>
      </div>
    </s.FormContainer>
  );
};

export default Aprovacao;
